






import { defineComponent } from '@vue/composition-api';
import { getFederationComponent } from '@src/federations/getFederationComponent';

export default defineComponent({
    name: 'TopManagerContainer',
    components: {
        FreeToPlayGameBase: getFederationComponent(() => import('gaming/FreeToPlayGameBase')),
    },
});

